import React, { useEffect } from 'react';
import { ReactComponent as HomeIcon } from "../../components/ui/styles/home.svg";
import { WrapperHead, WrapperHeadBtn } from "../edit";
import Breadcrumb, { BreadcrumbItem, BreadcrumbLink } from "../../components/ui/Breadcrumb";
import { ProjectBlock, Wrapper, EditPlatformSettingsTable, EditPlatformSettingsTableBody } from "../domains";
import AddMailerModal from "./AddMailerModal";
import { useDispatch, useSelector } from "react-redux";
import { fetchDomains, fetchMailers, fetchPlatformDomains, fetchPlatformMailers } from "../../redux/features/PlatformSettingSlice";
import UpdateMailerModal from './UpdateMailerModal';

const mailerTypes = { socketlabs: 'SocketLabs', ese: 'ESE' };


const MailerSettings = () => {
    const dispatch = useDispatch();
    const mailers = useSelector(state => state.PlatformSetting.mailers)

    useEffect(() => {
        dispatch(fetchPlatformMailers());
        dispatch(fetchPlatformDomains());
    }, []);

    return (
        <React.Fragment>
            <Wrapper>
                <WrapperHead>
                    <Breadcrumb primary>
                        <BreadcrumbLink to={"/home"}><BreadcrumbItem children={<HomeIcon />} /></BreadcrumbLink>
                        <BreadcrumbLink to={"/company-settings/overview"}><BreadcrumbItem children={"Setting"} /></BreadcrumbLink>
                        <BreadcrumbLink to={"/company-settings/edit"}><BreadcrumbItem children={"Platform Settings"} /></BreadcrumbLink>
                        <BreadcrumbLink to={"#"}><BreadcrumbItem children={"Mailer Settings"} /></BreadcrumbLink>
                    </Breadcrumb>
                    <WrapperHeadBtn>
                        <AddMailerModal />
                    </WrapperHeadBtn>
                </WrapperHead>
                <ProjectBlock>
                    <h4 className="smallTitle">Mailer Settings</h4>
                </ProjectBlock>
                <EditPlatformSettingsTable>
                    <EditPlatformSettingsTableBody>
                        {!mailers.length ?
                            <div style={{ padding: 20 }}>No mailers have been configured yet.</div> :
                            <table>
                                <thead>
                                    <tr>
                                        <th>Mailer</th>
                                        <th>Alias</th>
                                        <th>Type</th>
                                        <th>Domain</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {mailers.map((m) => {
                                        return (
                                            <tr key={m._id}>
                                                <td>{m.mailer}</td>
                                                <td>{m.alias}</td>
                                                <td>{mailerTypes[m.type]}</td>
                                                <td>{m.domain.domain}</td>
                                                <td><UpdateMailerModal mailer={m} /></td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        }

                    </EditPlatformSettingsTableBody>
                </EditPlatformSettingsTable>
            </Wrapper>
        </React.Fragment>
    )
}

export default MailerSettings;